import {
  transCustomerFeedbackAggreatorServiceLambdaHttpBindingInterceptor,
  TransCustomerFeedbackAggreatorServiceLambda,
} from '@amzn/coral_com-amazon-trans-feedback-tcfa-model-v-1';
import { TransCustomerFeedbackAggreatorServiceLambdaClientConfigFactory } from '@amzn/coral-config_trans-customer-feedback-aggreator-service-lambda';
import {
  CoralClientFactory,
  CoralFetchHandler,
  InterceptingHandler,
} from '@amzn/ihm-js-coral-client';
import GetDisplayableFeedbackQuestionnaireResponse from '../models/GetDisplayableFeedbackQuestionnaireResponse';
import SubmitFeedbackRequest from '../models/SubmitFeedbackRequest';

/** @typedef {import("@amzn/ihm-js-coral-client").CoralClientConfigFactory} CoralClientConfigFactory */
/** @typedef {import("@amzn/ihm-js-coral-client").CoralInterceptor} CoralInterceptor */

let transCustomerFeedbackAggreatorServiceClient = null;

/**
 * Initialize the TransCustomerFeedbackAggreatorServiceLambda client
 *
 * @param {string} env - String env
 * @param {CoralInterceptor} requestOptionsInterceptor - Interceptor
 */
export const initTransCustomerFeedbackAggreatorServiceClient = (
  env,
  requestOptionsInterceptor
) => {
  const clientFactory = new CoralClientFactory(
    [TransCustomerFeedbackAggreatorServiceLambdaClientConfigFactory],
    env,
    new InterceptingHandler(new CoralFetchHandler(), [
      transCustomerFeedbackAggreatorServiceLambdaHttpBindingInterceptor,
      requestOptionsInterceptor,
    ])
  );

  /**
   * Custom web server to override serialization/deserialization
   */
  class CustomTransCustomerFeedbackAggreatorServiceLambda extends TransCustomerFeedbackAggreatorServiceLambda {
    constructor(config, handler) {
      super(config, handler);

      this.handler.handlerChain.interceptor.operations.GetDisplayableFeedbackQuestionnaire.deserializationFn =
        GetDisplayableFeedbackQuestionnaireResponse.fromJson;
      this.handler.handlerChain.interceptor.operations.SubmitFeedback.serializationFn =
        SubmitFeedbackRequest.toJson;
    }
  }

  transCustomerFeedbackAggreatorServiceClient = clientFactory.get(
    CustomTransCustomerFeedbackAggreatorServiceLambda
  );
};

export const initCustomClient = (client) => {
  transCustomerFeedbackAggreatorServiceClient = client;
};

/**
 * Get the TransCustomerFeedbackAggreatorServiceLambda client if it has been initialized
 *
 * @returns {TransCustomerFeedbackAggreatorServiceLambda}
 */
export const getTransCustomerFeedbackAggreatorServiceClient = () => {
  if (!transCustomerFeedbackAggreatorServiceClient) {
    throw new Error(
      'TransCustomerFeedbackAggreatorServiceClient not initialized'
    );
  }

  return transCustomerFeedbackAggreatorServiceClient;
};

export default {
  initTransCustomerFeedbackAggreatorServiceClient,
  getTransCustomerFeedbackAggreatorServiceClient,
};
